import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CheckIcon, StarFullIcon, StarIcon, StarOneThirdIcon, StarTwoThirdsIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { primaryColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { useETEditorViewportOffset } from '../../../../../../hooks';
import { isSameMembership } from '../../helpers';
const priorityWrapperCss = "p2vvz88";
const PriorityWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(priorityWrapperCss, props.className)} />;
});
const checkIconWrapperCss = "c147numk";
const CheckIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkIconWrapperCss, props.className)} />;
});
const ICON_NAMES = {
  0: StarIcon,
  1: StarOneThirdIcon,
  2: StarTwoThirdsIcon,
  3: StarFullIcon
};
const PriorityIcon = ({
  Icon
}) => <Icon size="standard" />;

// i18n-tasks-use t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.priority_list.priority_0')
// i18n-tasks-use t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.priority_list.priority_1')
// i18n-tasks-use t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.priority_list.priority_2')
// i18n-tasks-use t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.priority_list.priority_3')
const PriorityItem = ({
  member,
  priority,
  updatePriority
}) => {
  const isCurrentPriority = member.priority === priority;
  return <Item onClick={() => updatePriority({
    memberToUpdate: member,
    priority
  })}>
      <PriorityIcon Icon={ICON_NAMES[priority]} />
      {I18n.t(`publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.priority_list.priority_${priority}`)}
      {isCurrentPriority && <CheckIconWrapper>
          <CheckIcon color={primaryColor} />
        </CheckIconWrapper>}
    </Item>;
};
const PriorityList = ({
  member,
  updatePriority
}) => {
  const viewportOffset = useETEditorViewportOffset();
  return <ViewportDropdownMenu viewportOffset={viewportOffset}>
      {[3, 2, 1, 0].map(priority => <PriorityItem key={priority} member={member} priority={priority} updatePriority={updatePriority} />)}
    </ViewportDropdownMenu>;
};
export const HostPriority = ({
  userPool,
  member,
  disabled,
  isLocked
}) => {
  const [togglePriorityDropdown, PriorityDropdown, isOpen] = useDropdown();
  const name = userPool ? `userPools.${userPool.position}.allocation_preference` : 'allocationPreference';
  const [{
    value: memberships
  }, _, {
    setValue,
    setTouched
  }] = useFormField({
    name: 'memberships'
  });
  const [{
    value: allocationPreference
  }] = useFormField({
    name
  });
  const hidePriority = userPool?.pooling_type === 'collective' || allocationPreference !== 'availability';
  if (hidePriority) return null;
  const updatePriority = ({
    memberToUpdate,
    priority
  }) => {
    const updatedMemberships = memberships.map(membership => ({
      ...membership,
      priority: isSameMembership(membership, memberToUpdate) ? priority : membership.priority
    }));
    setValue(updatedMemberships);
    setTouched(true);
  };
  if (isLocked) {
    return <PriorityWrapper>
        <PriorityIcon Icon={ICON_NAMES[member.priority || 0]} />
      </PriorityWrapper>;
  }
  return <PriorityWrapper>
      <IconButton disabled={disabled} aria-expanded={isOpen} onClick={togglePriorityDropdown} size="small" title={I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.round_robin_modal.change_priority')}>
        <PriorityIcon Icon={ICON_NAMES[member.priority || 0]} />
      </IconButton>
      <PriorityDropdown>
        <PriorityList member={member} updatePriority={updatePriority} />
      </PriorityDropdown>
    </PriorityWrapper>;
};

require("./host_priority.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./host_priority.js");